import Panel from "../../../components/panel/Panel";
import config from "../../../../config";

const Privacy = () => {

    return (
        <div className="flex-column gap">
        <Panel>
            <h1>Obchodné podmienky a ochrana osobných údajov.</h1>
            <p>
                Prevádzkovateľ v súlade s nariadením EP a R EÚ 2016/679 o ochrane fyzických osôb pri spracúvaní osobných
                údajov a o voľnom pohybe takýchto údajov, ktorým sa zrušuje smernica 95/46/ES (všeobecné nariadenie o
                ochrane údajov) a so zákonom č. 18/2018 Z. z. o ochrane osobných údajov v platnom znení, spracúva osobne
                údaje zákazníkov.
            </p>

            <h4><u>Identifikácia Prevádzkovateľa:</u></h4>
            <h2>{config.privacy.company.name}</h2>
            <p>
                {config.privacy.company.address}<br/>
                <br/>
                Prevádzka: {config.privacy.facility.address}<br/>
                IČO: {config.privacy.company.cin}<br/>
                IČ DPH: {config.privacy.company.vat}<br/>
                Číslo účtu: {config.privacy.account}<br/>
                Zapísaný v registri: {config.privacy.registration.name}<br/>
                Oddiel: {config.privacy.registration.section}<br/>
                Vložka číslo: {config.privacy.registration.insert}<br/>
            </p>
            <h4><u>Kontaktné údaje:</u></h4>
            <p>
                tel: {config.privacy.contact.phone}<br/>
                mail: {config.privacy.contact.mail}<br/>
            </p>

            <h2><u>Obchodné podmienky predajcu a poskytovateľa služby:</u></h2>
            <h3>I. Ustanovenia</h3>
            <ol>
                <li>Všeobecné ustanovenia
                    <ol>
                        <li>Tieto obchodné a reklamačné podmienky upravujú práva a povinnosti zmluvných strán
                            vyplývajúce z kúpnej zmluvy a záujmu o kúpu uzatvorenej medzi predávajúcim a kupujúcim,
                            ktorej predmetom je kúpa a predaj tovaru a služieb z ponuky internetovej stránky
                            predávajúceho www.motokaryzilina.sk, alebo priamo na prevádzke.
                        </li>
                        <li>Zobrazená kúpna cena za tovar zahŕňa aj daň z pridanej hodnoty vo výške stanovenej platným
                            právnym predpisom Slovenskej republiky.
                        </li>
                        <li>Predávajúci si vyhradzuje právo kedykoľvek upraviť cenu služby uvedenú na jeho internetovej
                            stránke, ktorú prevádzkuje predávajúci. Zmena ceny tovaru sa nevzťahuje na kúpne zmluvy
                            uzatvorené pred zmenou ceny, bez ohľadu na to, že ešte nedošlo k dodaniu služby.
                        </li>
                    </ol>
                </li>

                <li>Spôsob uzatvárania kúpnej zmluvy (objednávka)
                    <ol>
                        <li>Návrh na objednávku zasiela kupujúci predávajúcemu v mailovej komunikácii, kde sú uvedené
                            fakturačné údaje s IČO a DIČ prípadné IČ DPH ak je kupujúci platcom DPH. Týmto vzniká návrh
                            na uzavretie kúpnej zmluvy, predmetom ktorej je odplatný prevod vlastníckeho práva k tovaru
                            a služby označeného kupujúcim za kúpnu cenu a za podmienok, uvedených v tejto objednávke
                            (ďalej len „objednávka“).
                        </li>
                        <li>Kupujúci zaslaním objednávky súhlasí so znením všeobecných obchodných podmienok a
                            reklamačných podmienok ako aj s cenou objednaných tovarov a služieb a teda objednávka sa
                            stáva záväznou.
                        </li>
                        <li>Po odoslaní objednávky obdrží kupujúci na svoju e-mailovú adresu automaticky vykonávané
                            oznámenie o prijatí objednávky ( „potvrdenie doručenia objednávky“). Na e-mailovú adresu
                            kupujúceho môžu byť v prípade potreby zasielané všetky ďalšie informácie ohľadom jeho
                            objednávky.
                        </li>
                        <li>Potvrdenie doručenia obsahuje údaje o tom, že predávajúcemu bola doručená objednávka, je
                            akceptovaním návrhu na uzavretie kúpnej zmluvy.
                        </li>
                        <li>Kupujúci je odoslaním objednávky viazaný k zaplateniu kúpnej ceny objednaného tovaru a
                            služby, to je k povinnosti platby, s čím pred odoslaním objednávky súhlasil.
                        </li>
                    </ol>
                </li>

                <li>Práva a povinnosti zmluvných strán
                    <ol>
                        <li>Kupujúci je povinný:
                            <ul>
                                <li>prevziať objednaný tovar a službu,</li>
                                <li>zaplatiť dohodnutú odplatu predávajúcemu,</li>
                                <li>prekontrolovať neporušenosť resp. aj samotný tovar, alebo službu pri jeho
                                    preberaní,
                                </li>
                                <li>v prípade, že si kupujúci objednaný tovar neprevezme bez udania dôvodu, predávajúci
                                    si vyhradzuje právo uplatniť svoj nárok na náhradu vzniknutej škody
                                </li>
                            </ul>
                        </li>
                        <li>Predávajúci je povinný:
                            <ul>
                                <li>dodať zákazníkovi tovar a službu v požadovanej kvalite, množstve a v dohodnutej
                                    cene, hneď po kúpe tovaru prípadne služby
                                </li>
                            </ul>
                        </li>
                        <li>
                            Nezodpovedáme za:
                            <ul>
                                <li>oneskorené dodanie faktúry zavinené nesprávne udanou adresou prijímateľa,</li>
                                <li>za odložené veci (zákazníci majú možnosť hodnotné veci zamknúť do skriniek a počas
                                    pobytu a jazdy v našej prevádzke mať kľúč od skrinky pri sebe, ktorý pri odchode
                                    musia bezodkladne vrátiť)
                                </li>
                            </ul>
                        </li>
                    </ol>
                </li>

                <li>Dodacie a platobné podmienky
                    <ol>
                        <li>Ak sa predávajúci a kupujúci v kúpnej zmluve nedohodli inak, predávajúci je povinný dodať
                            službu kupujúcemu bezodkladne v deň dohodnutého termínu.
                        </li>
                        <li>Ak predávajúci nesplnil svoj záväzok dodať vec, alebo službu v lehote podľa prvej vety,
                            kupujúci ho vyzve, aby dodal vec v ním poskytnutej dodatočnej primeranej lehote. Ak
                            predávajúci nedodá vec, alebo službu ani v tejto dodatočnej primeranej lehote, kupujúci je
                            oprávnený odstúpiť od zmluvy.
                        </li>
                        <li>Predávajúci je oprávnený vyzvať kupujúceho na prevzatie tovaru, alebo služby aj pred
                            uplynutím lehoty na dodanie tovaru dohodnutej v kúpnej zmluve a navrhnúť iný termín.
                        </li>
                        <li>Kupujúci je povinný prevziať tovar a službu v mieste, ktoré je predávajúcim na to určené –
                            prevádzka motokárový areál Motokáry Žilina, kupujúci je povinný prevziať tovar a službu v
                            časovom rozsahu, ktorý je predávajúcim alebo jeho povereným zástupcom a kupujúcim dohodnuté
                            v kúpnej zmluve alebo iným spôsobom v čase pred doručovaním tovaru (ďalej len „Časový
                            rozsah“).
                        </li>
                        <li>Kupujúci je povinný prevziať tovar osobne alebo zabezpečiť, aby tovar a službu prevzala
                            osoba, ktorú splnomocní pre prípad svojej neprítomnosti na prevzatie tovaru a služby a
                            prípadne podpísať protokol – predbežný účet o zaplatení kúpnej ceny a doručení a odovzdaní
                            tovaru a služby. Tovar a služba sa považuje za dodaný a prevzatý kupujúcemu, okamihom
                            uplynutia dojednaného časového rozsahu a podpísaním predbežného účtu.
                        </li>
                        <li>Ak bude potrebné dodanie tovaru opakovať z dôvodu neprítomnosti kupujúceho na mieste a v
                            časovom rozsahu alebo v prípade, ak kupujúci bez predchádzajúceho písomného odstúpenia od
                            kúpnej zmluvy neprevezme tovar a službu ani v inom náhradnom termíne ponúknutého od
                            predávajúceho, vzniká predávajúcemu nárok na uplatnenie náhrady za vzniknutú škodu vo výške
                            skutočných nákladov.
                        </li>
                        <li>Kupujúci je oprávnený v prípade nedodania tovaru predávajúcim v lehote uvedenej v bode 4.2.
                            týchto obchodných podmienok odstúpiť od kúpnej zmluvy a predávajúci je povinný vrátiť
                            prípadnú zálohu.
                        </li>
                    </ol>
                </li>

                <li>Kúpna cena
                    <ol>
                        <li>Všetky uvádzané ceny pri tovare a za ponúkané služby sú konečné vrátane aktuálnej sadzby
                            DPH.
                        </li>
                        <li>Kupujúci je povinný zaplatiť predávajúcemu cenu tovaru dohodnutú v potvrdení objednávky
                            vrátane nákladov na doručenie tovaru (ďalej len "kúpna cena") formou hotovostnej platby,
                            alebo platobnou kartou v sídle predávajúceho, vložením na účet predávajúceho, bankovým
                            prevodom.
                        </li>
                        <li>Predávajúci si vyhradzuje právo na zmenu kúpnej ceny v prípade zmeny právnych predpisov,
                            alebo zmeny cien od dodávateľov alebo výrobcov tovaru. Predávajúci je viazaný cenou v
                            momente vystavenia objednávky.
                        </li>
                    </ol>
                </li>

                <li>Storno objednávky
                    <ol>
                        <li>Stornovať objednaný tovar a službu má zákazník právo do 3 dní pred termínom dodania a od
                            vytvorenia objednávky bez storno poplatku na tovar a službu. Storno objednávky nám zašlite
                            na adresu {config.privacy.contact.mail} kde uveďte všetky detaily objednávky, ktorú chcete zrušiť.
                        </li>
                    </ol>
                </li>

                <li>Odstúpenie od vybavenej objednávky
                    <ol>
                        <li>Ak predávajúci nemôže splniť svoje povinnosti vyplývajúce mu z kúpnej zmluvy - objednávky zo
                            závažného dôvodu, nedostupnosti tovaru a služby, alebo z dôvodov vyššej moci alebo ak ani
                            pri vynaložení všetkého úsilia, ktoré možno od neho spravodlivo požadovať nie je schopný
                            dodať tovar a službu zákazníkovi v lehote určenej týmito obchodnými podmienkami, predávajúci
                            je povinný o tejto skutočnosti okamžite informovať kupujúceho a zároveň je povinný ponúknuť
                            kupujúcemu náhradné plnenie alebo možnosť pre kupujúceho odstúpiť od kúpnej zmluvy
                            (stornovať objednávku). V prípade, ak kupujúci odstúpi od kúpnej zmluvy z dôvodov uvedených
                            v tomto bode týchto reklamačných a obchodných podmienok, je predávajúci povinný vrátiť
                            kupujúcemu už zaplatenú zálohu za tovar dohodnutý v kúpnej zmluve v lehote 14 dní od
                            oznámenia o odstúpení od zmluvy prevodom na účet určený kupujúcim, ak takáto záloha bola
                            zaplatená.
                        </li>
                        <li>Zákazník - spotrebiteľ je oprávnený odstúpiť od kúpnej zmluvy bez udania dôvodu v súlade s
                            ust. § 7 a nasl. Zákona č. 102/2014 Z.z. o ochrane spotrebiteľa pri predaji na diaľku (ďalej
                            len „Zákon o ochrane spotrebiteľa pri predaji na diaľku“) v lehote 14 dní odo dňa uzavretia
                            zmluvy o poskytnutí služby alebo zmluvy predávajúci včas a riadne splnil informačné
                            povinnosti podľa ust. § 3 Zákona o ochrane spotrebiteľa pri predaji na diaľku.
                        </li>
                        <li>Oznámenie o rozhodnutí pristúpiť k Odstúpeniu od zmluvy musí kupujúci urobiť písomnou formou
                            a to spôsobom nevzbudzujúcim pochybnosti, že dôjde ku odstúpeniu od zmluvy a následne
                            prostredníctvom mailu na adresu {config.privacy.contact.mail}
                        </li>
                        <li>Lehota na odstúpenie od zmluvy sa považuje za zachovanú, ak oznámenie o odstúpení od zmluvy
                            bolo odoslané predávajúcemu najneskôr v posledný deň lehoty podľa ust. § 7 ods. 1 Zákona o
                            ochrane spotrebiteľa pri predaji na diaľku, prípadne môže predajca uplatniť svoj nárok
                            súdnou cestou v ust. § 2 písm. a) zákona.
                        </li>
                    </ol>
                </li>

                <li>Záverečné ustanovenia
                    <ol>
                        <li>Predávajúci si vyhradzuje právo meniť a dopĺňať tieto všeobecné obchodné podmienky aj bez
                            predchádzajúceho upozornenia kupujúceho. V prípade zmeny všeobecných obchodných podmienok
                            alebo reklamačných podmienok, sa riadi celý proces nákupu prostredníctvom tých všeobecných
                            obchodných podmienok, ktoré boli platné v momente odoslania objednávky kupujúcim.
                        </li>
                        <li>Na vzťahy neupravené týmito obchodnými a reklamačnými podmienkami sa vzťahujú príslušné
                            ustanovenia Občianskeho zákonníka, Zákona, zákona č. 22/2004 Z.z. o elektronickom obchode a
                            o zmene a doplnení zákona č. 128/2002 Z.z. o štátnej kontrole vnútorného trhu vo veciach
                            ochrany spotrebiteľa a o zmene a doplnení niektorých zákonov v znení zákona č. 284/2002 Z.z.
                            v znení neskorších predpisov a Zákona č. 102/2014 Z.z. o ochrane spotrebiteľa pri predaji na
                            diaľku.
                        </li>
                        <li>Odoslaním objednávky kupujúci si prečítal všeobecné obchodné podmienky ako aj reklamačné
                            podmienky a súhlasí s ich znením. Kupujúci bude pred odoslaním objednávky vyzvaný, aby
                            zaškrtnutím políčka potvrdil, že sa s týmito obchodnými a reklamačnými podmienkami
                            oboznámil, prečítal ich, porozumel ich obsahu a v celom rozsahu s nimi súhlasí.
                        </li>
                        <li>Alternatívny spôsob riešenia sporov
                            <ol>
                                <li>Vážený spotrebiteľ. Ak sa domnievate, že sme porušili Vaše práva, alebo nie ste
                                    spokojný so spôsobom, ktorým sme vybavili Vašu reklamáciu, svoju žiadosť o nápravu
                                    nám zašlite na našu emailovú adresu: {config.privacy.contact.mail}
                                </li>
                                <li>Ak Vám odpovieme na túto žiadosť zamietavo, alebo na ňu neodpovieme do 30 dní od jej
                                    odoslania na uvedenú emailovú adresu, prípadne nebudete spokojný s našim riešením,
                                    potom na základe novelizovaného Zákona č. 102/2014 a Zákona č. 391/2015 o
                                    alternatívnom riešení spotrebiteľských sporov, máte právo na alternatívny
                                    (mimosúdny) spôsob riešenia sporov.
                                </li>
                                <li>Návrh môžete podať spôsobom určeným podľa §12 Zákona 391/2015 Z.z. Na podanie návrhu
                                    môžete využiť formulár, ktorého vzor je dostupný aj na webovom sídle príslušného
                                    ministerstva a každého subjektu alternatívneho riešenia sporov.
                                </li>
                            </ol>

                            Zoznam subjektov alternatívneho riešenia sporov k dátumu 10.4.2016 je tu:
                            http://www.mhsr.sk/zoznam-subjektov-alternativneho-riesenia-spotrebitelskych-sporov/146987s.
                            Spotrebiteľ má právo voľby, na ktorý z uvedených subjektov alternatívneho riešenia
                            spotrebiteľských sporov sa obráti.<br/>
                            Adresa na podávanie podaní v elektronickej podobe na Slovenskú obchodnú inšpekciu je
                            ars@soi.sk.<br/>
                            Subjekt alternatívneho riešenia sporov môže návrh spotrebiteľa odmietnuť, napr.:<br/>

                            <ol type="A">
                                <li>ak vyčísliteľná hodnota sporu nepresahuje sumu 20 eur.</li>
                                <li>ak je vzhľadom na všetky okolnosti zrejmé, že alternatívne riešenie sporu by bolo
                                    možné viesť len s vyvinutím neprimeraného úsilia, a podobne.
                                </li>
                            </ol>
                            <ol type="1">
                                <li>Spotrebiteľ môže podať sťažnosť aj prostredníctvom platformy alternatívneho riešenia
                                    sporov RSO, ktorá je dostupná online na:
                                    https://webgate.ec.europa.eu/odr/main/index.cfm?event=main.home.show&lng=SK.
                                    Sťažnosť tu môže podať spotrebiteľ žijúci v EÚ na obchodníka so sídlom v EÚ.
                                </li>
                                <li>Náklady spojené s alternatívnym riešením sporu znáša každá zo strán sporu samostatne
                                    bez možnosti ich náhrady.
                                </li>
                            </ol>
                        </li>
                    </ol>
                </li>
            </ol>

            <h3>II. Ochrana osobných údajov</h3>
            <p>
                <b>Všeobecné nariadenie o ochrane údajov</b> <i>(anglicky General Data Protection Regulation, skrátene
                GDPR), plným názvom Nariadenie Európskeho parlamentu a Rady (EÚ) 2016/679 z 27. apríla 2016 o ochrane
                fyzických osôb pri spracúvaní osobných údajov a o voľnom pohybe takýchto údajov, ktorým sa zrušuje
                smernica 95/46/ES (všeobecné nariadenie o ochrane údajov)</i>, je nariadenie Európskej únie, ktorého
                cieľom je výrazné zvýšenie ochrany osobných údajov občanov. V Úradnom vestníku Európskej únie bolo
                vyhlásené 27. apríla 2016. Nariadenia, v schválenom znení, sú priamo účinné pre každý členský štát EÚ. V
                slovenskom právnom poriadku je nariadenie premietnuté aj do zákona č. 18/2018 Z. z. o ochrane osobných
                údajov a o zmene a doplnení niektorých zákonov z 29. novembra 2017.<span id="ancor-3">[3]</span> Zákon
                18/2018 Z. z. je účinný na Slovensku rovnako ako GDPR od 25. mája 2018.
            </p>
            <p>
                Ako prevádzkovateľ motokárového areálu plne rešpektujeme súkromie všetkých zákazníkov, avšak pre
                vybavenie každej objednávky a každej kúpy služby u nás sú potrebné niektoré osobné údaje, ktoré budú
                použité výlučne len na účely komunikácie so zákazníkom a následné spracovanie a vybavenie objednávky a
                zakupovanej našej služby.
            </p>
            <p>
                <b>Prevádzkovateľ {config.privacy.company.name}, týmto vyhlasuje, že s osobnými údajmi svojich zákazníkov, získanými
                    registráciou, alebo zadaním objednávky, nakladá v zmysle hore uvedeného Zákona.</b>
            </p>
            <p>
                Z uvedeného zákona plynie i povinnosť neposkytovať získané osobné údaje zákazníkov tretím stranám.
                Výnimkou je len poskytnutie nevyhnutných údajov externému dodávateľovi – sprostredkovateľovi.
            </p>
            <p>
                Akékoľvek osobné údaje sú dôverné a nebudú inak zverejnené ani poskytnuté tretej osobe, s výnimkou
                sprostredkovateľa podľa zadaného mena a adresy. Vyplnením objednávkového alebo registračného formulára
                dávate súhlas na zhromažďovanie a archivovanie Vašich objednávok, alebo zadelenia do databázy,
                Predávajúceho môžete písomne požiadať, aby Vaše osobné údaje vymazal zo svojej databázy.
            </p>
            <p>
                Potvrdením objednávky v mailovej podobe, vy ako dotknutá osoba (zákazník) súhlasíte so spracovaním
                vašich osobných údajov poskytnutých v potvrdenej objednávke podľa zákona Z. z. o ochrane osobných údajov
                a o zmene a doplnení niektorých zákonov a potvrdzujete, že ste si prečítali obchodné podmienky,
                porozumeli ste im a ste kvalifikovaná osoba urobiť rozhodnutie o poskytnutí osobných údajov
                prevádzkovateľovi.
            </p>
            <p>
                V súlade so zákonom č. 22/2004 o obchode a nariadenia o ochrane osobných údajov ste povinný poskytnúť
                svoje osobné údaje v rozsahu uvedenom v Registračnom formulári a na webovom sídle. V súlade s § 10 ods.
                3 zákona č. 122/2013 Z. z. o ochrane osobných údajov je prevádzkovateľ, oprávnený spracúvať osobné údaje
                uvedené v Registračnom formulári ako aj údaje o nákupoch registrovaných užívateľov počas celého obdobia
                registrácie na účely spracúvania, ktoré sú popísané nižšie.
            </p>
            <p>
                Osobné údaje možno spracúvať len spôsobom ustanoveným zákonom o ochrane osobných údajov a v jeho
                medziach tak, aby nedošlo k porušeniu základných práv a slobôd dotknutých osôb (zákazníkov), najmä k
                porušeniu ich práva na zachovanie ľudskej dôstojnosti alebo k iným neoprávneným zásahom do ich práva na
                ochranu súkromia. Prevádzkovateľ sa zaručuje spracúvať osobné údaje v súlade s dobrými mravmi a konať
                spôsobom, ktorý neodporuje zákonu.
            </p>

            <h4>Účel spracúvania:</h4>
            <p>
                <ul>
                    <li>registrácia užívateľov, vedenie databázy registrovaných užívateľov a vedenia ich jázd a za
                        účelom ich zisku bonusových bodov.
                    </li>
                    <li>kamerový systém so záznamom, pre účel ochrany areálu, majetku spoločnosti a bezpečnosti
                        zamestnancov a zákazníkov od vstupu do areálu po chodníku, parkovisko, hlavný vstup do
                        prevádzky, vstup z parkoviska do prevádzky, vstup do barovej časti pri pokladni s audio video
                        kamerou, sedenie baru, pri nástupe do motokár, konferenčná miestnosť a samotná dráha indooru
                        kamerami pre identifikácie kolíznej situácie na trati, s recykláciou 14 dní v zmysle zákonu.
                    </li>
                    <li>spracovania objednávok, informovania užívateľov o stave objednávok a vedenia účtovných a iných
                        dokladov spojených s vybavením objednávky,
                    </li>
                    <li>vystavenie daňového dokladu, faktúry a dodacieho listu v IS účtovnej agende prevádzkovateľa,
                    </li>
                    <li>komunikácia s dotknutou osobou (zákazníkom) telefonicky alebo prostredníctvom elektronickej
                        pošty v súvislosti s vybavením objednávky a dodaním tovaru a služby, prípadne s riešením
                        reklamácie
                    </li>
                    <li>poskytnutie osobných údajov sprostredkovateľovi výlučne pre účely identifikácie dotknutých osôb
                        (zákazníkov) pred odovzdaním tovaru a služby sprostredkovateľom prostredníctvom telefonického
                        kontaktu a e mailu a následné doručenie tovaru a služby,
                    </li>
                    <li>vedenie používateľských účtov, ktoré obsahujú osobné údaje, ktoré môže dotknutá osoba (zákazník)
                        aktualizovať alebo písomnou žiadosťou požiadať prevádzkovateľa o aktualizáciu osobných údajov,
                        prípadne o likvidáciu osobných údajov v prípade, že účel spracúvania sa skončil, došlo k
                        porušeniu zákona alebo ak je predmetom činnosti prevádzkovateľa priamy marketing. Prevádzkovateľ
                        je povinný písomne vybaviť žiadosť dotknutej osoby najneskôr do 30 dní odo dňa doručenia
                        žiadosti, v prípade ak o vytvorenie účtu požiadala.
                    </li>
                    <li>evidencia a uchovávanie osobných údajov pre účely prípadných reklamácií</li>
                </ul>
            </p>
            <p>
                Prevádzkovateľ sa zaručuje zabezpečiť identifikáciu dotknutých osôb počas doby nie dlhšej, ako je
                nevyhnutné na dosiahnutie účelov spracúvania a zlikvidovať tie osobné údaje, ktorých účel spracúvania sa
                skončil.
            </p>
            <p>
                Prevádzkovateľ má celý areál zabezpečený kamerovým systémom so záznamom s recykláciou 14 dní.
            </p>
            <p>
                Zoznam osobných údajov: meno a priezvisko, fakturačná adresa, adresa pre doručenie tovaru a služby,
                telefónny kontakt, dátum narodenia, email, prípadne titul dotknutej osoby (zákazníka)
            </p>
            <p>
                Poskytnuté osobné údaje musia byť pravdivé a aktuálne. V prípade zmeny poskytnutých osobných údajov ste
                povinný spoločnosť informovať o ich zmene.
            </p>
            <p>
                Prevádzkovateľ je povinný chrániť spracúvané osobné údaje pred ich poškodením, zničením, stratou,
                zmenou, neoprávneným prístupom a sprístupnením, poskytnutím alebo zverejnením ako aj pred akýmikoľvek
                inými neprípustnými spôsobmi spracúvania. Prevádzkovateľ je povinný zachovávať mlčanlivosť o osobných
                údajoch, ktoré spracúva. Prevádzkovateľ je povinný získavať osobné údaje výlučne na vymedzený alebo
                ustanovený účel a je neprípustné získavať osobné údaje pod zámienkou iného účelu spracúvania alebo inej
                činnosti. Prevádzkovateľ je povinný zabezpečiť, aby sa spracúvali len také osobné údaje, ktoré svojím
                rozsahom a obsahom zodpovedajú účelu ich spracúvania a sú nevyhnutné na jeho dosiahnutie.
            </p>
            <p>
                Beriete na vedomie, že osobné údaje uvedené v registračnom formulári v registračnom kiosku budú
                poskytované sprostredkovateľom teda subjektom zmluvne spolupracujúcim s našou spoločnosťou ako sú
                dodávatelia cateringu, spracovateľská spoločnosť účtovnej agendy, IT správcovia databáz a pod.
            </p>
            <p>
                <b>Sprostredkovateľ: spoločnosť ekonomickej agendy a vedenia podvojného účtovníctva, dodávatelia
                    cateringových služieb, IT správca databázy, ID doklad – správca agendy vystavovania faktúr,
                    dodávateľ náhradných dielov, dodávatelia tovaru, banka, platobný terminál.</b>
            </p>
            <p>
                Beriete na vedomie, že Vaše práva pri spracúvaní osobných údajov ako dotknutej osoby upravuje § 28 a
                nasl. zákona č. 122/2013 Z. z. a nariadenia Európskeho parlamentu a Rady (EÚ) č. 2016/679 o ochrany
                fyzických osôb pri spracúvaní osobných údajov a voľnom pohybe takýchto údajov(nariadenie GDPR). Dotknutá
                osoba má právo na základe písomnej žiadosti, alebo e mailom od spoločnosti vyžadovať informácie, odpis a
                opravu jej osobných údajov spracúvaných spoločnosťou so sprievodným preukázaním jej hodnovernosti.
            </p>

            <h4>Účel, spôsob, právny základ a podmienky spracúvania a získavania osobných údajov:</h4>
            <p>
                <ul>
                    <li>registrácia užívateľov, vedenie databázy registrovaných užívateľov,</li>
                    <li>spracovania objednávok, informovania užívateľov o stave objednávok a vedenia účtovných a iných
                        dokladov spojených s vybavením objednávky,
                    </li>
                    <li>vystavenie daňového dokladu, faktúry a dodacieho listu v IS účtovnej agende prevádzkovateľa,
                    </li>
                    <li>vedenie a agenda zamestnancov, pracovné zmluvy a dohody prispôsobené na prevádzku motokárového
                        areálu,
                    </li>
                    <li>komunikácia s dotknutou osobou (zákazníkom) telefonicky alebo prostredníctvom elektronickej
                        pošty v súvislosti s vybavením objednávky a doručením tovaru, prípadne s riešením reklamácie
                    </li>
                    <li>poskytnutie osobných údajov sprostredkovateľovi výlučne pre účely identifikácie dotknutých osôb
                        (zákazníkov) pred odovzdaním tovaru sprostredkovateľom prostredníctvom telefonického kontaktu a
                        následné doručenie tovaru
                    </li>
                    <li>vedenie používateľských účtov, ktoré obsahujú osobné údaje, ktoré môže dotknutá osoba (zákazník)
                        aktualizovať alebo písomnou žiadosťou požiadať prevádzkovateľa o aktualizáciu osobných údajov,
                        prípadne o likvidáciu osobných údajov v prípade, že účel spracúvania sa skončil, došlo k
                        porušeniu zákona alebo ak je predmetom činnosti prevádzkovateľa priamy marketing.
                    </li>
                    <li>evidencia a uchovávanie osobných údajov pre účely prípadných reklamácií</li>
                </ul>
            </p>
            <p>
                Po ukončení platnosti súhlasu, po odvolaní súhlasu a po ukončení účelu spracovania budú osobné údaje
                bezodkladne zlikvidované. Prevádzkovateľ chráni spracúvané osobné údaje pred ich poškodením, zničením,
                stratou, zmenou, neoprávneným prístupom a sprístupnením v uzamknutej miestnosti, a heslom. Chráni ich
                pred poskytnutím alebo zverejnením ako aj pred akýmikoľvek inými neprípustnými spôsobmi spracúvania.
                Prevádzkovateľ zachováva mlčanlivosť o osobných údajoch, ktoré spracúva. Prevádzkovateľ získava osobné
                údaje výlučne na vymedzený alebo ustanovený účel a je neprípustné získavať osobné údaje pod zámienkou
                iného účelu spracúvania alebo inej činnosti. Prevádzkovateľ zabezpečil, aby sa spracúvali len také
                osobné údaje, ktoré svojím rozsahom a obsahom zodpovedajú účelu ich spracúvania a sú nevyhnutné na jeho
                dosiahnutie. Prevádzkovateľ získava osobné údaje v informačnom systéme prostredníctvom počítača úplne
                automatizovanými prostriedkami na základe registrácie zákazníka pri objednávaní tovaru, so súhlasom
                dotknutej osoby.
            </p>
            <p>
                <b>Označením políčka „Súhlasím“ v Registračnom formulári na kiosku v našej prevádzke a v súlade s Z. z.
                    o ochrane osobných údajov a nariadenia Európskeho parlamentu a Rady (EÚ) č. 2016/679 o ochrany
                    fyzických osôb pri spracúvaní osobných údajov a voľnom pohybe takýchto údajov (nariadenie GDPR)
                    udeľujete spoločnosti svoj súhlas so spracúvaním osobných údajov uvedených v Registračnom formulári
                    ako aj údajov o Vašich nákupoch počas celej doby platnosti súhlasu.</b>
            </p>
            <p>
                Svoj súhlas môže zákazník kedykoľvek odvolať.
            </p>
            <p>
                <b>Podľa uvedeného zákona a v spojitosti s § 23 zákona č. 18/2018 Z. z. o ochrane osobných údajov a o
                    zmene a doplnení niektorých zákonov (Zákon OOU) sa prevádzkovateľ motokárového areálu, že na
                    písomné, prianie zákazníka, vymaže jeho osobné údaje v zmysle zákonu do 30 dní jeho databázy.</b>
            </p>
            <p>
                <b>Písomnú žiadosť správne vyplnenú so všetkými osobnými údajmi pošlite na našu adresu doporučene a s
                    overeným podpisom.</b>
            </p>
            <p>
                <b>Je možné odovzdať žiadosť o odvolanie súhlasu aj osobne na našej prevádzke pri preukázaní totožnosti
                    s porovnaním s údajmi, ktoré ste uviedli do našej databázy. V tomto prípade budú vaše údaje vymazané
                    z databázy ihneď.</b>
            </p>
            <p>
                <b>Prevádzkovateľ si vyhradzuje právo odstúpiť od záruky bezpečného zaobchádzania s osobnými údajmi
                    zákazníkov v prípade napadnutia serveru neznámym páchateľom (hackerom). V takom prípade neplatia
                    vyššie uvedené pravidlá manipulácie s dátami, jedná sa o trestný čin, ktorý podlieha pod trestný
                    zákon s nehlasovacou povinnosťou predajcu orgánu činnom v trestnom konaní – polícii.</b>
            </p>
            <p>
                <b>Iným subjektom osobné údaje prevádzkovateľ neposkytuje a ani nezverejňuje.</b>
            </p>
            <p>
                <b>Orgán dozoru:</b><br/>
                Úrad na ochranu osobných údajov SR, Hraničná 12, Bratislava
            </p>

            <h4>Vyhlásenie o spracúvaní osobných údajov kamerovým systémom.</h4>
            <p>
                Kamerový systém je prevádzkovaný spoločnosťou {config.privacy.company.name} (ďalej len ako
                „spoločnosť“) s cieľom ochrany majetku, zdravia a bezpečnosti osôb pohybujúcich sa v priestoroch
                spoločnosti. Vaše osobné údaje spracúvame len na základe zákonných podmienok, ktoré sú uvedené v
                Nariadení <span id="ancor-1">[1]</span> alebo Zákone<span id="ancor-2">[2]</span> o ochrane osobných
                údajov. Našim cieľom je účinná ochrana vašich osobných údajov a transparentný postup pri poskytovaní
                informácií.
            </p>
            <p>
                <b>Zásady ochrany osobných údajov</b>
            </p>
            <p>
                Spoločnosť ako prevádzkovateľ má zákonnú povinnosť poskytnúť vaše osobné údaje pri kontrole, dozornej
                činnosti alebo na žiadosť oprávnených orgánov štátu alebo inštitúcií, ak to vyplýva z osobitných
                predpisov[3].
            </p>
            <p>
                Vaše osobné údaje budú uchovávané bezpečne, v súlade s bezpečnostnou politikou prevádzkovateľa a
                sprostredkovateľa a len po dobu nevyhnutnú na splnenie účelu spracúvania. Prístup k vašim osobným údajom
                budú mať výlučne osoby poverené prevádzkovateľom na spracúvanie osobných údajov, ktoré ich spracúvajú na
                základe pokynov prevádzkovateľa, v súlade s bezpečnostnou politikou prevádzkovateľa.
            </p>
            <p>
                Vaše osobné údaje sú zálohované, v súlade s retenčnými pravidlami prevádzkovateľa. Zo zálohových úložísk
                budú vaše osobnú údaje úplne vymazané v zmysle zákonu a v súlade s pravidlami zálohovania. Osobné údaje
                uchovávané na záložných úložiskách slúžia na predchádzanie bezpečnostným incidentom, najmä narušenia
                dostupnosti údajov v dôsledku bezpečnostného incidentu. Spoločnosť je povinná zabezpečovať zálohovanie
                údajov v súlade s bezpečnostnými požiadavkami Nariadenia a Zákona o ochrane osobných údajov.
            </p>
            <p>
                Pri spracúvaní osobných údajov prevádzkovateľom ste <b>dotknutou osobou</b>, t. j. osobou o ktorej sú
                spracúvané osobné údaje, ktoré sa jej týkajú.
            </p>
            <p>
                V súlade s Nariadením a Zákonom o ochrane osobných údajov spoločnosť ako prevádzkovateľ, spracúva vaše
                osobné údaje v rozsahu a za podmienok ustanovených v osobitných predpisoch. Vaše osobné údaje spracúvame
                na základe zákonných podmienok, uvedených v čl. 6 Nariadenia. Prostredníctvom monitorovania kamerovým
                systémom sú vaše osobné údaje spracúvané na účel ochrany majetku, zdravia a bezpečnosti osôb
                pohybujúcich sa v priestoroch spoločnosti na základe zákonných podmienok, uvedených v čl. 6 ods. 1 písm.
                f) Nariadenia, na základe oprávneného záujmu spoločnosti (prevádzkovateľa). Oprávnený záujem spoločnosti
                spočíva najmä v ochrane bezpečnosti a zdravia klientov a ochrane majetku spoločnosti.
            </p>
            <p>
                Vaše osobné údaje/ kamerový záznam budú spracúvané po dobu 3 dní od ich vyhotovenia; po uplynutí tejto
                lehoty spoločnosť záznamy s odbornou starostlivosťou zlikviduje, okrem záznamov využitých na
                preukazovanie právnych nárokov. Záznamy môžu byť využité aj na preukazovanie právnych nárokov a
                spoločnosť ich bude spracúvať pod dobu nevyhnutnú na ich preukazovanie a 1 rok po ukončení účelu
                spracúvania.
            </p>
            <p>
                <b>Zodpovedná osoba</b><br/>
                {config.privacy.authorizedPerson}<br/>
                Mail: {config.privacy.contact.mail}<br/>
                Telefón: {config.privacy.contact.phone}<br/>
            </p>

            <h4>Vaše práva podľa nariadenia a Zákona o ochrane osobných údajov</h4>
            <h5>Právo na prístup</h5>
            <p>
                Máte právo na poskytnutie kópie osobných údajov, ktoré o vás máme k dispozícii, ako aj na informácie o
                tom, ako vaše osobné údaje používame.
            </p>
            <p>
                Vo väčšine prípadov vám budú vaše osobné údaje poskytnuté v písomnej listinnej forme, pokiaľ
                nepožadujete iný spôsob ich poskytnutia. Ak ste o poskytnutie týchto informácií požiadali elektronickými
                prostriedkami, budú vám poskytnuté elektronicky, ak to bude technicky možné.
            </p>

            <h5>Právo na opravu</h5>
            <p>
                Prijímame primerané opatrenia, aby sme zabezpečili presnosť, úplnosť a aktuálnosť informácií, ktoré o
                vás máme k dispozícii. Ak si myslíte, že údaje, ktorými disponujeme sú nepresné, neúplné alebo
                neaktuálne, prosím, neváhajte nás požiadať, aby sme tieto informácie upravili, aktualizovali alebo
                doplnili.
            </p>

            <h5>Právo na vymazanie</h5>
            <p>
                Máte právo nás požiadať o vymazanie vašich osobných údajov, napríklad v prípade, ak osobné údaje, ktoré
                sme o Vás získali, už viac nie sú potrebné na naplnenie pôvodného účelu spracúvania. Vaše právo je však
                potrebné posúdiť z pohľadu všetkých relevantných okolností. Napríklad, môžeme mať určité právne a
                regulačné povinnosti, čo znamená, že nebudeme môcť vašej žiadosti vyhovieť.
            </p>

            <h5>Právo na obmedzenie spracúvania</h5>
            <p>
                Za určitých okolností ste oprávnený nás požiadať, aby sme prestali používať vaše osobné údaje. Ide
                napríklad o prípady, keď si myslíte, že osobné údaje, ktoré o vás máme, môžu byť nepresné alebo keď si
                myslíte, že už vaše osobné údaje nepotrebujeme využívať.
            </p>

            <h5>Právo na prenosnosť údajov</h5>
            <p>
                Za určitých okolností máte právo požiadať nás o prenos osobných údajov, ktoré ste nám poskytli, na inú
                tretiu stranu podľa vášho výberu. Právo na prenosnosť sa však týka len osobných údajov, ktoré sme od vás
                získali na základe súhlasu alebo na základe zmluvy, ktorej ste jednou zo zmluvných strán.
            </p>

            <h5>Právo namietať</h5>
            <p>
                Máte právo namietať voči spracúvaniu údajov, ktoré je založené na našich legitímnych oprávnených
                záujmoch. V prípade, ak nemáme presvedčivý legitímny oprávnený dôvod na spracúvanie a vy podáte
                námietku, nebudeme vaše osobné údaje ďalej spracúvať.
            </p>

            <h5>Právo podať sťažnosť</h5>
            <p>
                Ak chcete podať sťažnosť na spôsob, akým sú vaše osobné údaje spracúvané, vrátane uplatnenia vyššie
                uvedených práv, môžete sa obrátiť na našu Zodpovednú osobu. Všetky vaše podnety a sťažnosti riadne
                preveríme.
            </p>

            <p>
                Ak nie ste spokojný s našou odpoveďou, alebo sa domnievate, že vaše osobné údaje spracúvame
                nespravodlivo alebo nezákonne, môžete podať sťažnosť na dozorný orgán, ktorým je Úrad na ochranu
                osobných údajov Slovenskej republiky, https://dataprotection.gov.sk, Hraničná 12, 820 07 Bratislava 27;
                tel. číslo: +421 /2/ 3231 3214; E-mail: statny.dozor@pdp.gov.sk.
            </p>

            <p>
                V prípade akýchkoľvek otázok, týkajúcich sa spracúvania vašich osobných údajov nás môžete kontaktovať
                prostredníctvom našej Zodpovednej osoby.
            </p>

            <p>
                <a rel="stylesheet" href="#ancor-1">[1] Nariadenie Európskeho parlamentu a Rady (EÚ) 2016/679 z 27.
                    apríla 2016 o ochrane fyzických osôb pri spracúvaní osobných údajov a o voľnom pohybe takýchto
                    údajov, ktorým sa zrušuje smernica 95/46/ES (všeobecné nariadenie o ochrane údajov).</a><br/>
                <a rel="stylesheet" href="#ancor-2">[2] Zákon č. 18/2018 Z. z. o ochrane osobných údajov.</a><br/>
                <a rel="stylesheet" href="#ancor-3">[3] Napríklad Zákon č. 171/1993 Z. z. o Policajnom zbore; zákon č.
                    18/2018 Z. z. o ochrane osobných údajov.</a><br/>
            </p>
        </Panel>
        </div>
    )
}

export default Privacy;